<button class="loginBtn loginBtn--facebook" (click)="facebookLogin()">
	{{'TRANS_REMOTE_LOGIN.TRANS_WITH' | translate}} Facebook
</button>
<button class="loginBtn loginBtn--google" #loginRef (click)="googleLogin()">
	{{'TRANS_REMOTE_LOGIN.TRANS_WITH' | translate}} Google
</button>